import { editGroup, getFlexModelInfo, getScenario } from '@/services/flexGroup';
import { Button, Form, Input, InputNumber, message, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import type { GroupsType } from './index';

interface EditProps {
  record: GroupsType | null;
  visible: boolean;
  refreshTable: () => void;
  onCancel: () => void;
}

const EditModal = (editProps: EditProps) => {
  const { visible, onCancel, record, refreshTable } = editProps;
  const [form] = Form.useForm<GroupsType>();
  const [loading, setLoading] = useState(false);
  const [scenarios, setScenarios] = useState<any[]>([]);
  const [checkScenarios, setCheckScenarios] = useState(false);

  const standbyEnableSelectOptions = [
    {
      label: '是',
      value: true,
    },
    {
      label: '否',
      value: false,
    },
  ];

  useEffect(() => {
    getScenario().then((res) => {
      setScenarios(res?.data.details);
    })
    record && form.setFieldsValue(record);
    form.setFieldValue(
      'isRecycledStandbyEnable',
      record?.isRecycledStandbyEnable === '1' ? true : false,
    ); // 由于列表接口返回值与更新接口设置值不同，单独设置一次
  }, []);

  const onOk = () => {
    form.validateFields().then((res) => {
      setLoading(true);
      const id = editProps.record?.id;
      if (id) {
        editGroup({ ...res, id })
          .then((msg) => {
            if (msg?.data.code === 'SUCCESS') {
              message.success('编辑成功');
              onCancel();
              refreshTable();
            }
          })
          .finally(() => setLoading(false));
      }
    });
  };

  const onAutoGet = () => {
    const addr = form.getFieldValue('modelUrl');
    console.log(form.getFieldValue('matchToken'))
    getFlexModelInfo({ modelUrl: addr }).then(res => {
      console.log(res)
      if (res.data.details) {
        form.setFieldsValue({ matchToken: res.data.details.matchToken })
      }
    })
  }

  return (
    <Modal
      title="编辑"
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      width={600}
      maskClosable={false}
      okButtonProps={{ loading: loading }}
    >
      <div className="editModalContainer">
        <Form<GroupsType>
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          form={form}
          labelWrap={true}
        >
          <Form.Item
            label="名称"
            name="name"
          // rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="最大实例数" name="max" rules={[{ required: true }]}>
            <InputNumber />
          </Form.Item>
          <Form.Item label="期望实例数" name="expected" rules={[{ required: true }]}>
            <InputNumber />
          </Form.Item>
          <Form.Item label="standBy实例数" name="standBy" rules={[{ required: true }]}>
            <InputNumber />
          </Form.Item>
          {/* <Form.Item
                        label="Abort策略"
                        name="abortStrategy"
                    >
                        <Input.TextArea />
                    </Form.Item> */}
          <Form.Item
            label="实例工作状态接口"
            name="workStatusCallbackUrl"
            rules={[{ required: true }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="动态回收停机服务器间隔时间"
            name="recycledShutdownCycle"
            rules={[{ required: false }]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="动态回收standby间隔时间"
            name="recycledStandbyCycle"
            rules={[{ required: false }]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label="配置是否可动态回收standby"
            name="isRecycledStandbyEnable"
            rules={[{ required: false }]}
          >
            <Select options={standbyEnableSelectOptions} />
          </Form.Item>
          <Form.Item label="模型地址" name="modelUrl" >
            <Input />
          </Form.Item>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form.Item labelCol={{ span: 5, offset: 2 }}
              wrapperCol={{ span: 16 }} label="匹配口令" name="matchToken" style={{ flex: 1 }}>
              <Input />
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
              {
                () => (
                  <Button onClick={onAutoGet} style={{ marginBottom: 24 }} disabled={!form.getFieldValue('modelUrl')}>自动获取</Button>
                )
              }
            </Form.Item>
          </div>
          <Form.Item noStyle shouldUpdate>
            {() => (
              <Form.Item label="业务场景" name="scenario" rules={[{ required: !!form.getFieldValue('modelUrl') }]} >
                <Select >
                  {scenarios.map((item) => (
                    <Select.Option value={item.value} key={item.value}>{item.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default EditModal;
